import StatisticWithLabelColored from './StatisticWithLabelColored';

export default StatisticWithLabelColored;